<script setup>
const props = defineProps({
  data: Object
})
const { getImageList } = useImageListData();
const { data: imageList } = await getImageList();

let imageListData = null;
if (props.data.override) {
    imageListData = imageList.value.imageList
} else {
    imageListData = props.data.imageList
}

const getListImageAlt = (image) =>
  resolveMediaAlt(image);

</script>

<template>
  <div class="block image-list">
    <div class="container">
      <ul class="image-list__list">
        <li
          class="image-list__list-item"
          v-for="list_item in imageListData"
          :key="list_item.id"
        >
          <div class="list-icon-box" v-if="list_item.image">
            <NuxtImg 
              :src="list_item?.image?.url" 
              :alt="getListImageAlt(list_item?.image)" 
              loading="lazy"
              decoding="async"
              aria-hidden="true"
            />
          </div>
          <article class="list-text-box" v-html="list_item.content"></article>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.image-list {
  
  .image-list__list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .image-list__list-item {
    display: flex;
    gap: 10px;

    .list-icon-box {
      width: 32px;
      height: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      img {
        vertical-align: middle;
        border-style: none;
        max-width: 21px;
        max-height: 21px;
      }
    }
  }

  .list-text-box {
    display: flex;
    align-items: center;

    > p {
      margin: 0;
    }
  }
}
</style>
